import React from 'react';
import SimpleContext from './../context/SimpleContext';
import { useContext } from 'react';
import SearchProduct from './SearchProduct'

const SearchProducts = () => {

    const context = useContext(SimpleContext);
  
    return ( 
        <div className='Searchproducts'>
            <div className="otherPagesHeader">
                <div className="headersNames">
                    <h6 style={{margin:"0"}}>جستجو</h6>
                </div>
            </div>
                {
                    context.SearchedProducts.length ? 
                    context.SearchedProducts.map(product =>
                        <div key = {product.id}>
                            <SearchProduct 
                            key={product.id}
                            key={product.id}
                            name = {product.name}
                            price = {product.price}
                            userPrice = {product.user_price}
                            slug = {product.slug}
                            min = {product.minimum}
                            max = {product.maximum}
                            proid = {product.brandID}
                            isSahmiyeh = {product.sahmie_bandi}
                            isvalid = {product.status}
                            numUnit = {product.number_in_unit}
                            numSale = {product.number_in_sale}
                            unit = {product.unit}
                            stock={product.stock}
                            category={product.category}
                            ulImg={product.ULImg}
                            dlImg={product.DLImg}
                            urImg={product.URImg}
                            drImg={product.DRImg}
                            mojud={product.FreshStatus}
                            /> 
                        </div>
                    ):null
                }
                
            </div> 
     );
}
 
export default SearchProducts;